import React from 'react'
import StandardProductDashboard from './StandardProductDashboard'

/**
 * Product — Sky's product dashboard.
 *
 * Four campaigns roll up here - TV, Broadband, Cinema and Mobile - so it is the only department whose totals are a sum across propositions. The component is ProductLineDashboard, not ProductDashboard, because 'product' means both a Sky department and this codebase's product-slug concept.
 *
 * It is deliberately three lines. A department's dashboard is an ARRANGEMENT,
 * and today every department arranges the same way, so this file's only job is
 * to name the product and its copy. When Product asks for something different,
 * this is the file that changes: drop StandardProductDashboard, compose the kit
 * primitives directly, and nothing else in the codebase moves.
 */
export const ProductLineDashboard: React.FC = () => (
  <StandardProductDashboard
    product="product"
    title="Product"
    subtitle="The TV, broadband, mobile and cinema propositions."
  />
)

export default ProductLineDashboard
